(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-description"] && !Shopify.designMode) return;
  try {
    const initializeCollectionDescriptions = (scope) => {
    scope.querySelectorAll('[data-collection-description]').forEach((container) => {
      if (container.dataset.collectionDescriptionInitialized === 'true') {
        return;
      }

      const content = container.querySelector('[data-collection-description-content]');
      const toggle = container.querySelector('[data-collection-description-toggle]');
      const moreLabel = container.querySelector('[data-collection-description-more]');
      const lessLabel = container.querySelector('[data-collection-description-less]');

      if (!content || !toggle || !moreLabel || !lessLabel) {
        return;
      }

      container.dataset.collectionDescriptionInitialized = 'true';

      const setExpanded = (expanded) => {
        container.classList.toggle('collection-description--expanded', expanded);
        toggle.setAttribute('aria-expanded', expanded.toString());
        moreLabel.hidden = expanded;
        lessLabel.hidden = !expanded;
      };

      const updateOverflow = () => {
        container.classList.remove('collection-description--collapsible');
        const title = container.parentElement?.querySelector('[data-collection-title]');

        if (title) {
          const titleWidth = Math.ceil(title.getBoundingClientRect().width);
          container.style.setProperty('--collection-description-title-width', `${titleWidth}px`);
        }

        const computedStyle = window.getComputedStyle(content);
        const fontSize = Number.parseFloat(computedStyle.fontSize) || 16;
        const lineHeight = Number.parseFloat(computedStyle.lineHeight) || fontSize * 1.5;
        const visibleLines = window.matchMedia('(max-width: 749px)').matches ? 3 : 2;
        const isLong = content.scrollHeight > lineHeight * visibleLines + 2;

        container.classList.toggle('collection-description--collapsible', isLong);
        toggle.hidden = !isLong;

        if (!isLong) {
          setExpanded(false);
        }
      };

      toggle.addEventListener('click', () => {
        setExpanded(toggle.getAttribute('aria-expanded') !== 'true');
      });

      let resizeTimer;
      window.addEventListener(
        'resize',
        () => {
          window.clearTimeout(resizeTimer);
          resizeTimer = window.setTimeout(updateOverflow, 120);
        },
        { passive: true }
      );

      window.requestAnimationFrame(updateOverflow);

      if (document.fonts?.ready) {
        document.fonts.ready.then(updateOverflow);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeCollectionDescriptions(document));
  } else {
    initializeCollectionDescriptions(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeCollectionDescriptions(event.target);
  });
  } catch(e) { console.error(e); }
})();

})();
